


import React, { useState } from 'react';
import { Container, Card, Form, Button, Row, Col } from 'react-bootstrap';
import api from '../api/api';

const RegistrationThankYou = () => (
  <Container className="text-center py-5">
    <div className="p-5 bg-white shadow-sm rounded border">
      <h1 className="text-success mb-4">Verification Sent! 📧</h1>
      <p className="lead">We've sent an account activation link to your email address.</p>
      <p className="text-muted">Please click the link in that email to finalize your account and receive your <b>100 credits</b>.</p>
      <div className="mt-4">
        <small className="text-info">Don't see it? Check your spam folder.</small>
      </div>
    </div>
  </Container>
);
export default RegistrationThankYou;
